export interface ImpressumPageData {}

export interface ImpressumPageProps extends ImpressumPageData {}
